export default "__VITE_ASSET__DGRRMGsl__"